import * as React from 'react';
import CanadaProvinces from '../Data/canadian-provinces.json';
import USSates from '../Data/states.json';
import Parishes from '../Data/jamaican-parishes.json';
import { Select } from 'antd';
import moment from 'moment';
import Countries from '../Data/countries.json';

export default class FormUtility {

  //Get canada provinces
  static getCanadaProvices(): Array<{ value: string; text: string }> {
    return this.convertToOptionArray(CanadaProvinces);
  }

  //Select component with canada province option
  public static provinceSelector() {
    const { Option } = Select;
    return (
      <Select showSearch={true} allowClear={true}>
        {FormUtility.getCanadaProvices().map(province => (
          <Option key={province.value} value={province.value}>{province.text}</Option>
        ))}
      </Select>
    );
  }

  //Get states
  static getUSStates(): Array<{ value: string; text: string }> {
    return this.convertToOptionArray(USSates);
  }

  //Select component with states option
  public static stateSelector() {
    const { Option } = Select;
    return (
      <Select showSearch={true} allowClear={true}>
        {FormUtility.getUSStates().map(state => (
          <Option key={state.value} value={state.value}>{state.text}</Option>
        ))}
      </Select>
    );
  }

  //Get parishes
  static getParishes(): Array<{ value: string; text: string }> {
    return this.convertToOptionArray(Parishes);
  }

  //Select component with parish option
  public static parishSelector() {
    const { Option } = Select;
    return (
      <Select showSearch={true} allowClear={true}>
        {FormUtility.getParishes().map(parish => (
          <Option key={parish.value} value={parish.value}>{parish.text}</Option>
        ))}
      </Select>
    );
  }

  //Select component with country option
  public static countrySelector() {
    const { Option } = Select;
    return (
      <Select showSearch={true} allowClear={true} style={{ fontWeight: "normal" }} >
        {Countries.countries.map(country => (
          <Option key={country.value} value={country.value}>{country.label}</Option>
        ))}
      </Select>
    );
  }

  public static getExpiryDateParts(value?: string): { month: string; year: string } | undefined {
    if (value === undefined) {
      return undefined;
    }
    const expiryMonth = value!.split('/', 1)[0];
    const expiryYear = moment(value!.split('/')[1], 'YY').format('YYYY');
    return { month: expiryMonth, year: expiryYear };
  }

  private static convertToOptionArray(input: any) {
    const data = new Array<{ value: string; text: string }>();
    for (const value in input) {
      if (input.hasOwnProperty(value)) {
        const text = input[value];
        data.push({ value, text });
      }
    }
    return data;
  }
}
